import React from 'react';
import { Container, Typography, Paper, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Visibility, Security, Speed, HealthAndSafety } from '@mui/icons-material';

const AboutUs = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Paper 
        elevation={8}
        sx={{ 
          borderRadius: 4,
          backgroundColor: '#ffffff',
          boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
          border: '1px solid rgba(0,0,0,0.1)',
          p: { xs: 4, sm: 6 }
        }}
      >
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 50%, #e55039 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 800,
            textAlign: 'center',
            mb: 4
          }}
        >
          O aplikaci Nechci Lepek
        </Typography>
        
        <Typography paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.6, mb: 3 }}>
          Aplikace Nechci Lepek vznikla z osobní potřeby usnadnit život lidem s celiaklií a lepkovou senzitivitou. 
          Naším cílem je poskytovat rychlé, spolehlivé a přesné informace o obsahu lepku v potravinách prostřednictvím 
          jednoduchého skenování čárového kódu.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Naše mise
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Věříme, že každý má právo na bezpečné a informované rozhodování o své stravě. Bezlepková dieta může být 
          náročná, ale s správnými nástroji se stává snazší a bezpečnější. Nechci Lepek je navržena tak, aby 
          odstranila nejistotu při nakupování a umožnila uživatelům rychle identifikovat bezpečné produkty.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Proč jsme aplikaci vytvořili
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Nakupování pro osoby s celiaklií často znamená dlouhé čtení etiket, nejistotu ohledně složek a obavy 
          z kontaminace. Rozhodli jsme se tyto problémy řešit technologií, která spojuje rozsáhlé databáze 
          potravinových produktů s intuitivním uživatelským rozhraním.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Naše hodnoty
        </Typography>
        <List sx={{ mb: 3 }}>
          <ListItem>
            <ListItemIcon>
              <Security sx={{ color: '#4caf50' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Bezpečnost" 
              secondary="Prioritou je poskytování přesných a ověřených informací o obsahu lepku"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Speed sx={{ color: '#ff9800' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Jednoduchost" 
              secondary="Rychlé a intuitivní rozhraní pro okamžité získání informací"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <Visibility sx={{ color: '#2196f3' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Transparentnost" 
              secondary="Jasné a srozumitelné informace o zdrojích dat a metodách kontroly"
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <HealthAndSafety sx={{ color: '#e91e63' }} />
            </ListItemIcon>
            <ListItemText 
              primary="Zdraví" 
              secondary="Podpora zdravého životního stylu osob s lepkovou senzitivitou"
            />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Technologie a data
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Aplikace využívá pokročilé algoritmy pro analýzu složení produktů a propojuje se s ověřenými databázemi 
          potravin. Naše systémy jsou navrženy tak, aby poskytovaly aktuální informace a minimalizovaly riziko chyb 
          při identifikaci lepku v produktech.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ color: '#333', fontWeight: 600, mt: 4, mb: 2 }}>
          Budoucí vývoj
        </Typography>
        <Typography paragraph sx={{ lineHeight: 1.6, mb: 3 }}>
          Neustále pracujeme na vylepšování aplikace. Plánujeme rozšíření databáze, přidání dalších funkcí 
          pro sledování stravy a zlepšování přesnosti detekce lepku. Vaše zpětná vazba nám pomáhá určovat 
          směr dalšího vývoje.
        </Typography>

        <Box sx={{ mt: 4, p: 3, bgcolor: '#f5f5f5', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#333', fontWeight: 600 }}>
            Kontakt
          </Typography>
          <Typography paragraph>
            Pokud máte jakékoli dotazy, návrhy nebo zpětnou vazbu ohledně aplikace Nechci Lepek, 
            neváhejte nás kontaktovat. Vaše zkušenosti a připomínky jsou pro nás velmi důležité 
            a pomáhají nám vytvářet lepší nástroje pro bezlepkovou komunitu.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default AboutUs; 